import { HttpService } from "../http";

export class NoticeTypeService extends HttpService {
  fetchNoticeTypes = async (payload: any = {}): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/notice-type`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addNoticeType = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/notice-type`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateNoticeType = async (id: number, payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/notice-type/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteNoticeType = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/notice-type/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
